import AxiosWrapper from "../../../basecomp/base/AxiosWrapper";
import Logger from "../../../basecomp/base/Logger";

const Base_URL = process.env.REACT_APP_BE_URL;
const currentUrl = window.location.origin;

const {
  axiosGetCallWithToken,
  axiosDeleteCallWithToken,
  axiosGetCallHeaderWithToken,
  axiosPutCallWithToken,
} = AxiosWrapper;

export const updateWareHouseLoc = async (id, storage_bin_loc, storage_loc) => {
  let response;
  try {
    response = await axiosPutCallWithToken(
      `${Base_URL}/label_print/updateWarehouseLoc?id=${id}&storage_bin_loc=${storage_bin_loc}&storage_loc=${storage_loc}`
    );
  } catch (error) {
    let sendError = error;
    if (
      sendError.response !== undefined &&
      sendError.response.data !== undefined &&
      sendError.response.data.message !== undefined
    ) {
      sendError = new Error(sendError.response.data.message);
    } else {
      sendError = new Error(
        "Something unexpected happened." +
        "If the issue persists, please contact our support team for assistance."
      );
    }
    Logger.printStackTrace("Error fetching data:", error);

    throw sendError;
  }
  if (response === undefined) {
    throw new Error("No response");
  }
  if (response.status >= 200 && response.status <= 204) {
    if (
      response.data !== undefined &&
      response.data.status !== undefined &&
      response.data.status === 204
    ) {
      throw new Error(response.data.message);
    } else {
      return response;
    }
  }
};

export const fetchWareHouseLoc = async () => {
  let response;
  try {
    response = await axiosGetCallWithToken(
      `${Base_URL}/label_print/getAllWarehouseLocs`
    );
  } catch (error) {
    let sendError = error;
    if (
      sendError.response !== undefined &&
      sendError.response.data !== undefined &&
      sendError.response.data.message !== undefined
    ) {
      sendError = new Error(sendError.response.data.message);
    } else {
      sendError = new Error(
        "Something unexpected happened." +
        "If the issue persists, please contact our support team for assistance."
      );
    }
    Logger.printStackTrace("Error fetching data:", error);

    throw sendError;
  }
  if (response === undefined) {
    throw new Error("No response");
  }
  if (response.status >= 200 && response.status <= 204) {
    if (
      response.data !== undefined &&
      response.data.status !== undefined &&
      response.data.status === 204
    ) {
      throw new Error(response.data.message);
    } else {
      return response;
    }
  }
};

export const deleteWareHouseLoc = async (id, type) => {
  let response;
  try {
    response = await axiosDeleteCallWithToken(
      `${Base_URL}/label_print/deleteWarehouseLoc?id=${id}&type=${type}`
    );
  } catch (error) {
    let sendError = error;
    if (
      sendError.response !== undefined &&
      sendError.response.data !== undefined &&
      sendError.response.data.message !== undefined
    ) {
      sendError = new Error(sendError.response.data.message);
    } else {
      sendError = new Error(
        "Something unexpected happened." +
        "If the issue persists, please contact our support team for assistance."
      );
    }
    Logger.printStackTrace("Error fetching data:", error);

    throw sendError;
  }
  if (response === undefined) {
    throw new Error("No response");
  }
  if (response.status >= 200 && response.status <= 204) {
    if (
      response.data !== undefined &&
      response.data.status !== undefined &&
      response.data.status === 204
    ) {
      throw new Error(response.data.message);
    } else {
      return response;
    }
  }
};

export const getWareHouseLocPdf = async (id, type, isPrint) => {
  let response;
  const request_id = `${Date.now()}-${Math.random().toString(36).substr(2, 6)}`;
  try {
    const idParam = id === undefined ? `` : `&id=${id}`;
    response = await axiosGetCallHeaderWithToken(
      `${Base_URL}/label_print/getWarehousePdf?type=${type}&url=${currentUrl}${idParam}&request_id=${request_id}&print=${isPrint}`,
      "application/pdf"
    );
  } catch (error) {
    let sendError = error;
    if (
      sendError.response !== undefined &&
      sendError.response.data !== undefined &&
      sendError.response.data.message !== undefined
    ) {
      sendError = new Error(sendError.response.data.message);
    } else {
      sendError = new Error(
        "Something unexpected happened." +
        "If the issue persists, please contact our support team for assistance."
      );
    }
    Logger.printStackTrace("Error fetching data:", error);

    throw sendError;
  }
  if (response === undefined) {
    throw new Error("No response");
  }
  if (response.status >= 200 && response.status <= 204) {
    if (
      response.data !== undefined &&
      response.data.status !== undefined &&
      response.data.status === 204
    ) {
      throw new Error(response.data.message);
    } else {
      return response;
    }
  }
};

export const getSampleWareHouseLocUploadFile = async (type) => {
  let response;
  try {
    response = await axiosGetCallHeaderWithToken(
      `${Base_URL}/label_print/getSampleCsv?type=${type}`,
      { responseType: "blob" }
    );
  } catch (error) {
    let sendError = error;
    if (
      sendError.response !== undefined &&
      sendError.response.data !== undefined &&
      sendError.response.data.message !== undefined
    ) {
      sendError = new Error(sendError.response.data.message);
    } else {
      sendError = new Error(
        "Something unexpected happened." +
        "If the issue persists, please contact our support team for assistance."
      );
    }
    Logger.printStackTrace("Error fetching data:", error);

    throw sendError;
  }
  if (response === undefined) {
    throw new Error("No response");
  }
  if (response.status >= 200 && response.status <= 204) {
    if (
      response.data !== undefined &&
      response.data.status !== undefined &&
      response.data.status === 204
    ) {
      throw new Error(response.data.message);
    } else {
      return response;
    }
  }
};

export const getAllWarehouseLocsMaterials = async (
  terminal_id,
  storage_bin,
  storage_loc
) => {
  let response;
  try {
    if (
      terminal_id !== "null" &&
      storage_bin !== "null" &&
      storage_loc !== "null"
    ) {
      let scanSessionId = sessionStorage.getItem("scan_session_id");

      if (!scanSessionId) {
        scanSessionId = crypto.randomUUID();
        sessionStorage.setItem("scan_session_id", scanSessionId);
      }
      response = await axiosGetCallWithToken(
        `${Base_URL}/label_print/getAllWarehouseLocsMaterials?storage_bin=${storage_bin}&storage_loc=${storage_loc}&session_id=${scanSessionId}`
      );
    }
  } catch (error) {
    let sendError = error;
    if (
      sendError.response !== undefined &&
      sendError.response.data !== undefined &&
      sendError.response.data.message !== undefined
    ) {
      sendError = new Error(sendError.response.data.message);
    } else {
      sendError = new Error(
        "Something unexpected happened." +
        "If the issue persists, please contact our support team for assistance."
      );
    }
    Logger.printStackTrace("Error fetching data:", error);

    throw sendError;
  }
  if (response === undefined) {
    throw new Error("No response");
  }
  if (response.status >= 200 && response.status <= 204) {
    if (
      response.data !== undefined &&
      response.data.status !== undefined &&
      response.data.status === 204
    ) {
      throw new Error(response.data.message);
    } else {
      return response;
    }
  }
};

export const getAllWarehouseLocsMaterials1 = async (
  terminal_id,
  storage_bin,
  storage_loc
) => {
  let response;
  try {
    if (
      terminal_id !== "null" &&
      storage_bin !== "null" &&
      storage_loc !== "null"
    ) {

      sessionStorage.setItem(
        "logingsoneurl",
        `/warehouse/whs-location-info?terminal_id=${terminal_id}&storage_bin=${storage_bin}&storage_loc=${storage_loc}`
      );
      response = await axiosGetCallWithToken(
        `${Base_URL}/label_print/getAllCountedWarehouseLocsMaterials?storage_bin=${storage_bin}&storage_loc=${storage_loc}`
      );
    }
  } catch (error) {
    let sendError = error;
    if (
      sendError.response !== undefined &&
      sendError.response.data !== undefined &&
      sendError.response.data.message !== undefined
    ) {
      sendError = new Error(sendError.response.data.message);
    } else {
      sendError = new Error(
        "Something unexpected happened." +
        "If the issue persists, please contact our support team for assistance."
      );
    }
    Logger.printStackTrace("Error fetching data:", error);

    throw sendError;
  }
  if (response === undefined) {
    throw new Error("No response");
  }
  if (response.status >= 200 && response.status <= 204) {
    if (
      response.data !== undefined &&
      response.data.status !== undefined &&
      response.data.status === 204
    ) {
      throw new Error(response.data.message);
    } else {
      return response;
    }
  }
};